'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/function-bind/index.js
// module id = 617
// module chunks = 0